import { cn } from '../lib/cn';

interface BrandMarkProps {
  showWordmark: boolean;
  wordmark?: string;
}

export function BrandMark({
  showWordmark,
  wordmark = 'Ferry Tools',
}: BrandMarkProps) {
  return (
    <div className={cn('flex shrink-0 items-center gap-2.5')}>
      <img
        src="/brand-icon.png"
        alt=""
        aria-hidden="true"
        width={36}
        height={36}
        className="h-9 w-9 shrink-0 object-contain"
      />
      {showWordmark ? (
        <span className="text-base font-semibold tracking-tight text-gray-900 dark:text-white">
          {wordmark}
        </span>
      ) : null}
    </div>
  );
}
